import { globalGraphqlRequest } from '@root/src/core/utils/backend-service.ts';

import { Rule, RuleApi, RuleCreate } from '../types/automation-rules.type';
import {
    mapRuleFromApiToVm,
    mapRuleFromVmToCreateApi,
    mapRuleFromVmToEditApi,
} from './settings-automation-rules.mapper';
import { allRulesQuery, createRuleQuery, editRuleQuery } from './settings-automation-rules.queries';

const DEFAULT_PAGE_SIZE = 1000; //Temp until BE pagination fix
const DEFAULT_PAGE = 1;

export const getAllRules = (
    page: number = DEFAULT_PAGE,
    perPage: number = DEFAULT_PAGE_SIZE
): Promise<{ data: Rule[]; total: number }> =>
    globalGraphqlRequest(allRulesQuery(), { page, perPage }).then((response) => ({
        data: response.data.rules.data.map((rule: RuleApi) => mapRuleFromApiToVm(rule)),
        total: response.data.rules.totalElements,
    }));

export const createRule = async (rule: RuleCreate): Promise<{ result: string }> =>
    globalGraphqlRequest(createRuleQuery(), { rule: mapRuleFromVmToCreateApi(rule) }).then(() => ({
        result: 'ok',
    }));

export const editRule = async (rule: Rule): Promise<{ result: string }> =>
    globalGraphqlRequest(editRuleQuery(), { id: rule.id, rule: mapRuleFromVmToEditApi(rule) }).then(() => ({
        result: 'ok',
    }));
